import { call, put, select, takeLatest, fork, all } from 'redux-saga/effects';
import axios from 'axios';
import { SagaIterator } from 'redux-saga';

import { updateQueryString } from 'services/router/actions';
// @ts-ignore
import { idTokenSelector } from 'services/auth/selectors';
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
// @ts-ignore
import { selectCurrentSeasonId } from 'services/currentSeasonId/selectors';
import { formatTimesheetHoliday } from 'services/timesheetHolidays/utils';
import { setSubmitHasFailed } from 'services/virtualizedTable/actions';

import { ERROR_MODAL_QUERY_STRING_PARAM } from 'components/ErrorModal/constants';

import {
    RequestedCreateTimesheetHolidayAction,
    RequestedUpdateTimesheetHolidayAction
} from './types';
import {
    succeededCreateTimesheetHoliday,
    failedCreateTimesheetHoliday,
    succeededUpdateTimesheetHoliday,
    failedUpdateTimesheetHoliday,
    setTimesheetHoliday
} from './actions';
import {
    TIMESHEET_HOLIDAY_CREATE_REQUESTED,
    TIMESHEET_HOLIDAY_UPDATE_REQUESTED
} from './constants';

// Environment
const { REACT_APP_API_URL } = process.env;

export function* postTimesheetHoliday(
    action: RequestedCreateTimesheetHolidayAction
): SagaIterator {
    const [idToken, organizationId] = yield all([
        select(idTokenSelector),
        select(selectCurrentOrganizationId)
    ]);
    const url = `${REACT_APP_API_URL}/v1/TimesheetHolidays`;

    try {
        const response = yield call(axios, url, {
            method: 'post',
            headers: {
                Authorization: idToken
            },
            data: {
                ...action.payload,
                organizationId
            }
        });
        yield all([
            put(succeededCreateTimesheetHoliday(response)),
            put(setTimesheetHoliday(formatTimesheetHoliday(response.data)))
        ]);
    } catch (error) {
        yield all([
            put(failedCreateTimesheetHoliday(error)),
            put(setSubmitHasFailed(true)),
            put(
                updateQueryString({
                    [ERROR_MODAL_QUERY_STRING_PARAM]: 'TIMESHEET_HOLIDAY_CREATE'
                })
            )
        ]);
    }
}

export function* patchTimesheetHoliday(
    action: RequestedUpdateTimesheetHolidayAction
): SagaIterator {
    const [idToken, seasonId] = yield all([
        select(idTokenSelector),
        select(selectCurrentSeasonId)
    ]);

    const {
        payload: { timesheetHolidayId, timesheetHoliday }
    } = action;

    try {
        const url = `${REACT_APP_API_URL}/v1/TimesheetHolidays/${timesheetHolidayId}`;

        const response = yield call(axios, url, {
            method: 'patch',
            headers: {
                Authorization: idToken
            },
            data: {
                seasonId,
                entityIds: timesheetHoliday.entityIds
            }
        });
        yield all([
            put(succeededUpdateTimesheetHoliday(response)),
            put(setTimesheetHoliday(formatTimesheetHoliday(response.data)))
        ]);
    } catch (error) {
        yield all([
            put(failedUpdateTimesheetHoliday(error)),
            put(setSubmitHasFailed(true)),
            put(
                updateQueryString({
                    [ERROR_MODAL_QUERY_STRING_PARAM]: 'TIMESHEET_HOLIDAY_UPDATE'
                })
            )
        ]);
    }
}

export function* watchCreateTimesheetHoliday(): SagaIterator {
    yield takeLatest(TIMESHEET_HOLIDAY_CREATE_REQUESTED, postTimesheetHoliday);
}

export function* watchUpdateTimesheetHoliday(): SagaIterator {
    yield takeLatest(TIMESHEET_HOLIDAY_UPDATE_REQUESTED, patchTimesheetHoliday);
}

export default function* timesheetHolidaySetsSagas(): SagaIterator {
    yield all([
        fork(watchCreateTimesheetHoliday),
        fork(watchUpdateTimesheetHoliday)
    ]);
}
